export default "__VITE_PUBLIC_ASSET__2d1865c3__"